import { Assignment, InsertDriveFile } from '@mui/icons-material';
import Settings from '@mui/icons-material/Settings';
import { Divider, Drawer, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import Icon from '@mui/material/Icon';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ADMIN_NAV, CENTRES_NAV, CLIENTS_NAV, DOCUMENTS_NAV, FORMS_APPROVALS_NAV, FORMS_NAV, PRIMARY_NAV, USER_NAV } from '../../_const/navigation.const';
import { accountService } from '../../_services/accounts.service';
import ExpandableList from './components/expandableList';

//todo
// const logoImg = require('../../_assets/images/HC_Logo.png');
const drawerWidth = 240;

export default function AppSidebar(params: { isOpen: boolean }) {
    let navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(params.isOpen);
    const [selectedListItem, setSelectedListItem] = useState(null);

    useEffect(() => {
        setIsOpen(params.isOpen);
    }, [params.isOpen]);

    return (
        <Drawer
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                "& .MuiDrawer-paper": {
                    width: drawerWidth,
                    paddingTop: { xs: "56px", sm: "64px" },
                    boxSizing: "border-box",
                },
            }}
            variant="persistent"
            open={isOpen}
            id={"sidebarNavDrawer"}
            anchor="left">
            {(PRIMARY_NAV.length > 0) &&
                <List>
                    {PRIMARY_NAV.map(nav =>
                        <ListItemButton key={nav.name} onClick={e => navigate(nav.url)}>
                            <ListItemIcon><Icon>{nav.icon}</Icon></ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    )}
                    <Divider sx={{ marginTop: "8px" }} />
                </List>
            }

            {(CLIENTS_NAV.length > 0) &&
                <List>
                    {CLIENTS_NAV.map(nav =>
                        <ListItemButton key={nav.name} onClick={e => navigate(nav.url)}>
                            <ListItemIcon><Icon>{nav.icon}</Icon></ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    )}
                    <Divider sx={{ marginTop: "8px" }} />
                </List>
            }

            {(CENTRES_NAV.length > 0) &&
                <List>
                    {CENTRES_NAV.map(nav =>
                        <ListItemButton key={nav.name} onClick={e => navigate(nav.url)}>
                            <ListItemIcon><Icon>{nav.icon}</Icon></ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    )}
                    <Divider sx={{ marginTop: "8px" }} />
                </List>
            }

            {DOCUMENTS_NAV.length > 0 &&
                <>
                    {accountService.isAdmin &&
                        <>
                            <ExpandableList
                                label="Documents"
                                icon={<InsertDriveFile />}
                                items={DOCUMENTS_NAV}
                                selectedItem={selectedListItem}
                                setSelectedItem={setSelectedListItem}
                            />
                            <Divider />
                        </>
                    }
                </>
            }


            {FORMS_APPROVALS_NAV.length > 0 &&
                <>
                    <List>
                        {FORMS_APPROVALS_NAV.map(nav =>
                            <ListItemButton key={nav.name} onClick={e => navigate(nav.url)}>
                                <ListItemIcon><Icon>{nav.icon}</Icon></ListItemIcon>
                                <ListItemText primary={nav.name} />
                            </ListItemButton>
                        )}
                        <Divider sx={{ marginTop: "8px" }} />
                    </List>
                </>
            }

            {FORMS_NAV.length > 0 &&
                <>
                    {accountService.isAdmin &&
                        <>
                            <ExpandableList
                                label="Forms"
                                icon={<Assignment />}
                                items={FORMS_NAV}
                                selectedItem={selectedListItem}
                                setSelectedItem={setSelectedListItem}
                            />
                            <Divider />
                        </>
                    }
                </>
            }


            {ADMIN_NAV.length > 0 &&
                <>
                    {accountService.isAdmin &&
                        <ExpandableList
                            label="Setup"
                            icon={<Settings />}
                            items={ADMIN_NAV}
                            selectedItem={selectedListItem}
                            setSelectedItem={setSelectedListItem}
                        />
                    }
                </>
            }

            {(USER_NAV.length > 0) &&
                <List>
                    <Divider />

                    {USER_NAV.map(nav =>
                        <ListItemButton key={nav.name} onClick={nav.onClick} sx={{ marginTop: "8px" }}>
                            <ListItemIcon><Icon>{nav.icon}</Icon></ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    )}

                </List>
            }
        </Drawer>
    );
}